import { parseLocale } from 'lib/constants/localization'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import _useTranslation from 'lib/hooks/_useTranslation'
import SearchResults from 'components/feature/App/pages/SearchResults'
import { useEffect } from 'react'
import { onPageEnter } from 'lib/tracking/pageEnter'
import Meta from 'components/modules/SEO/Meta'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { searchResultRoute } from 'lib/constants/routes'
import { isDeviceMobile } from 'lib/features/deviceInfo'

const Container = styled.div`
    background-color: ${theme.colors.white};
    @media (max-width: 750px) {
        section {
            padding: 20px 0px;
        }
    }
`

const SearchKnows = () => {
    const { t } = _useTranslation('app')
    const isMobile = isDeviceMobile()

    useEffect(() => {
        onPageEnter()
    }, [])

    return (
        <Container>
            <section>
                <Meta title={t('app/searchsectionTitle')} description="" />

                <SearchResults searchUrl={searchResultRoute} isApp={false} autoFocus={isMobile} />
            </section>
        </Container>
    )
}

export default SearchKnows

export const getStaticProps: GetStaticProps = async (props) => ({
    props: {
        ...(await serverSideTranslations(parseLocale(props.locale).interfaceLanguageCode, [
            'common',
            'app',
            'knows',
            'plusPlan',
        ])),
    },
})
